let i18nInstance;
export const setI18n = instance => {
  i18nInstance = instance;
};
export const getI18n = () => i18nInstance;